import { render, staticRenderFns } from "./MiniGalleryConexion.vue?vue&type=template&id=16a236cf&"
import script from "./MiniGalleryConexion.vue?vue&type=script&lang=js&"
export * from "./MiniGalleryConexion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports